import { ComponentProps, FC } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";

import { useTranslate } from "@/hooks/useTranslate";
import { ChildrenOrI18nType } from "@/utils/react";
import { cn } from "@/utils/tailwind";

import { textVariants } from "./RmText/variants";

export type RmLabelPropsType = ComponentProps<typeof LabelPrimitive.Root> &
  ChildrenOrI18nType;

export const RmLabel: FC<RmLabelPropsType> = ({
  className,
  children,
  i18nKey,
  i18nOptions,
  ...props
}) => {
  const i18nText = useTranslate(i18nKey, i18nOptions);

  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        textVariants({
          weight: "medium",
        }),
        className,
      )}
      {...props}>
      {children ?? i18nText}
    </LabelPrimitive.Root>
  );
};
